import { BuyerListRightMenuStructure } from "../store";
import { BUYER_LIST_RIGHT_MENU } from '../actions-constants/buyerListRightMenu.constants'
const initialBuyerListRightMenuStructure: BuyerListRightMenuStructure = new BuyerListRightMenuStructure



export function buyerListRightMenuReducer(buyerListRightMenu: BuyerListRightMenuStructure = initialBuyerListRightMenuStructure, action): BuyerListRightMenuStructure {

  switch (action.type) {
    case BUYER_LIST_RIGHT_MENU.SET_INITIAL_PURCHASE_DATE:
      return {
        ...buyerListRightMenu,
        purchaseDate: action.purchaseDate
      }

    case BUYER_LIST_RIGHT_MENU.SET_INITIAL_STATUS:
      return {
        ...buyerListRightMenu,
        status: action.status
      }

    case BUYER_LIST_RIGHT_MENU.SET_INITIAL_ORDER:
      return {
        ...buyerListRightMenu,
        order: action.order
      }

    case BUYER_LIST_RIGHT_MENU.SET_INITIAL_STATE_MENU:
      return {
        ...buyerListRightMenu,
        stateMenu: action.stateMenu
      }

    case BUYER_LIST_RIGHT_MENU.SET_INITIAL_SHOW_DETAILS:
      return {
        ...buyerListRightMenu,
        showDetails: action.showDetails
      }

    default:
      return buyerListRightMenu
  }
}